import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.184 5.03a2.273 2.273 0 0 0-3.143 0 2.074 2.074 0 0 0 0 2.999 2.273 2.273 0 0 0 3.143 0 2.074 2.074 0 0 0 0-2.998ZM4.065 4.028a3.673 3.673 0 0 1 5.094 0 3.471 3.471 0 0 1 .412 4.529l3.71 2.59 6.618-4.62a.7.7 0 0 1 .802 1.148L14.505 12l6.196 4.326a.7.7 0 0 1-.802 1.148l-6.617-4.62-3.71 2.59a3.471 3.471 0 0 1-.413 4.53 3.673 3.673 0 0 1-5.094 0 3.474 3.474 0 0 1 0-5.007 3.677 3.677 0 0 1 4.466-.488.704.704 0 0 1 .104-.089L12.059 12 8.635 9.61a.703.703 0 0 1-.104-.089 3.677 3.677 0 0 1-4.466-.488 3.474 3.474 0 0 1 0-5.006ZM8.184 15.97a2.273 2.273 0 0 0-3.143 0 2.074 2.074 0 0 0 0 2.998 2.273 2.273 0 0 0 3.143 0 2.074 2.074 0 0 0 0-2.998Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CutIcon24.js.map